<h3>{{ 'admin.param.infosGenerales' | traduire }}</h3>

<form class="form-ajout" (ngSubmit)="enregistrerParametres()">
  <div class="ligne">
    <div>
      <label>{{ 'admin.param.nomFestival' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.nomFestival" name="nomFestival">
    </div>
    <div>
      <label>{{ 'admin.param.edition' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.edition" name="edition">
    </div>
  </div>
  <div class="ligne">
    <div>
      <label>{{ 'admin.param.dates' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.dates" name="dates">
    </div>
    <div>
      <label>{{ 'admin.param.adresse' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.adresse" name="adresse">
    </div>
  </div>
  <div class="ligne">
    <div>
      <label>{{ 'admin.param.email' | traduire }}</label>
      <input type="email" [(ngModel)]="parametres.email" name="email">
    </div>
    <div>
      <label>{{ 'admin.param.telephone' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.telephone" name="telephone">
    </div>
  </div>
  <div class="ligne">
    <div>
      <label>Facebook</label>
      <input type="text" [(ngModel)]="parametres.facebook" name="facebook">
    </div>
    <div>
      <label>Instagram</label>
      <input type="text" [(ngModel)]="parametres.instagram" name="instagram">
    </div>
  </div>
  <div class="ligne">
    <div>
      <label>{{ 'admin.param.dateOuverture' | traduire }}</label>
      <input type="datetime-local" [(ngModel)]="parametres.dateOuverture" name="dateOuverture">
    </div>
    <div>
      <label>{{ 'admin.param.bandeau' | traduire }}</label>
      <input type="text" [(ngModel)]="parametres.noteInfo" name="noteInfo" [placeholder]="'admin.param.bandeauPlaceholder' | traduire">
    </div>
  </div>
  <p class="confirmation" *ngIf="messageParametres">{{ messageParametres }}</p>
  <button type="submit">{{ 'admin.param.enregistrer' | traduire }}</button>
</form>

<h3>{{ 'admin.param.apparence' | traduire }}</h3>
<p class="astuce-section">{{ 'admin.param.apparenceTexte' | traduire }}</p>

<form class="form-ajout" (ngSubmit)="enregistrerParametres()">
  <app-photo-uploader [label]="'admin.param.photoHero' | traduire"
    [value]="parametres.photoHero" (valueChange)="parametres.photoHero = $event"></app-photo-uploader>

  <app-photo-uploader [label]="'admin.param.photoAme' | traduire"
    [value]="parametres.photoAme" (valueChange)="parametres.photoAme = $event"></app-photo-uploader>

  <app-photo-uploader [label]="'admin.param.photoTheatreJour' | traduire"
    [value]="parametres.photoTheatreJour" (valueChange)="parametres.photoTheatreJour = $event"></app-photo-uploader>

  <app-photo-uploader [label]="'admin.param.photoTheatreNuit' | traduire"
    [value]="parametres.photoTheatreNuit" (valueChange)="parametres.photoTheatreNuit = $event"></app-photo-uploader>

  <button type="submit">{{ 'admin.param.enregistrerVisuels' | traduire }}</button>
</form>

<h3>{{ 'admin.param.changerMdp' | traduire }}</h3>

<form class="form-ajout" (ngSubmit)="changerMotDePasse()">
  <label>{{ 'admin.param.mdpActuel' | traduire }}</label>
  <input type="password" [(ngModel)]="ancienMotDePasse" name="ancienMotDePasse" required>

  <div class="ligne">
    <div>
      <label>{{ 'admin.param.nouveauMdp' | traduire }}</label>
      <input type="password" [(ngModel)]="nouveauMotDePasse" name="nouveauMotDePasse" minlength="8" required>
      <p class="astuce-mdp">Au moins 8 caractères, avec une lettre et un chiffre.</p>
    </div>
    <div>
      <label>{{ 'admin.param.confirmerMdp' | traduire }}</label>
      <input type="password" [(ngModel)]="confirmationMotDePasse" name="confirmationMotDePasse" required>
    </div>
  </div>

  <p class="confirmation" *ngIf="messagePassword">{{ messagePassword }}</p>
  <p class="erreur" *ngIf="erreurPassword">{{ erreurPassword }}</p>

  <button type="submit">{{ 'admin.param.changerMdpBtn' | traduire }}</button>
</form>

<h3>Comptes administrateurs</h3>
<p class="astuce-section">
  Toute personne connectée avec un de ces comptes a un accès complet au back-office
  (mêmes droits que toi). N'ajoute que des personnes de confiance.
</p>

<table class="table-liste">
  <thead>
    <tr>
      <th>Identifiant</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let u of utilisateurs">
      <td>{{ u.username }}</td>
      <td>
        <button class="btn-supprimer" (click)="supprimerUtilisateur(u)" [disabled]="utilisateurs.length <= 1">
          Supprimer
        </button>
      </td>
    </tr>
  </tbody>
</table>

<form class="form-ajout" (ngSubmit)="ajouterUtilisateur()">
  <label>Nouvel identifiant</label>
  <input type="text" [(ngModel)]="nouvelUtilisateur.username" name="nouvelUsername" required>

  <label>Mot de passe</label>
  <input type="password" [(ngModel)]="nouvelUtilisateur.password" name="nouveauPasswordAdmin" minlength="8" required>
  <p class="astuce-mdp">Au moins 8 caractères, avec une lettre et un chiffre.</p>

  <p class="confirmation" *ngIf="messageUtilisateur">{{ messageUtilisateur }}</p>
  <p class="erreur" *ngIf="erreurUtilisateur">{{ erreurUtilisateur }}</p>

  <button type="submit">+ Ajouter un administrateur</button>
</form>
